

// EVENT_ALLERGIES Getby Id
const EVENT_ALLERGIES_REQUEST_GETBYID = 'EVENT_ALLERGIES_REQUEST_GETBYID';
const EVENT_ALLERGIES_SUCCESS_GETBYID = 'EVENT_ALLERGIES_SUCCESS_GETBYID';
const EVENT_ALLERGIES_FAILURE_GETBYID = 'EVENT_ALLERGIES_FAILURE_GETBYID';

// EVENT_ALLERGIES Getby Id ALL
const EVENT_ALLERGIES_REQUEST_GETBYALL_ID = 'EVENT_ALLERGIES_REQUEST_GETBYALL_ID';
const EVENT_ALLERGIES_SUCCESS_GETBYALL_ID = 'EVENT_ALLERGIES_SUCCESS_GETBYALL_ID';
const EVENT_ALLERGIES_FAILURE_GETBYALL_ID = 'EVENT_ALLERGIES_FAILURE_GETBYALL_ID';

//EVENT_ALLERGIESUpdate
const EVENT_ALLERGIES_REQUEST_UPDATE = 'EVENT_ALLERGIES_REQUEST_UPDATE';
const EVENT_ALLERGIES_SUCCESS_UPDATE = 'EVENT_ALLERGIES_SUCCESS_UPDATE';
const EVENT_ALLERGIES_FAILURE_UPDATE = 'EVENT_ALLERGIES_FAILURE_UPDATE';

//EVENT_ALLERGIESADD
const EVENT_ALLERGIES_REQUEST_ADD = 'EVENT_ALLERGIES_REQUEST_ADD';
const EVENT_ALLERGIES_SUCCESS_ADD = 'EVENT_ALLERGIES_SUCCESS_ADD';
const EVENT_ALLERGIES_FAILURE_ADD = 'EVENT_ALLERGIES_FAILURE_ADD';

//EVENT_ALLERGIESDELETE

const EVENT_ALLERGIES_REQUEST_DELETE = 'EVENT_ALLERGIES_REQUEST_DELETE';
const EVENT_ALLERGIES_SUCCESS_DELETE = 'EVENT_ALLERGIES_SUCCESS_DELETE';
const EVENT_ALLERGIES_FAILURE_DELETE = 'EVENT_ALLERGIES_FAILURE_DELETE';

export {
    EVENT_ALLERGIES_REQUEST_GETBYID, EVENT_ALLERGIES_SUCCESS_GETBYID, EVENT_ALLERGIES_FAILURE_GETBYID,
    EVENT_ALLERGIES_REQUEST_UPDATE, EVENT_ALLERGIES_SUCCESS_UPDATE, EVENT_ALLERGIES_FAILURE_UPDATE,
    EVENT_ALLERGIES_REQUEST_ADD, EVENT_ALLERGIES_SUCCESS_ADD, EVENT_ALLERGIES_FAILURE_ADD,
    EVENT_ALLERGIES_REQUEST_DELETE, EVENT_ALLERGIES_SUCCESS_DELETE, EVENT_ALLERGIES_FAILURE_DELETE,
    EVENT_ALLERGIES_REQUEST_GETBYALL_ID, EVENT_ALLERGIES_SUCCESS_GETBYALL_ID, EVENT_ALLERGIES_FAILURE_GETBYALL_ID,
    // ALLERGIES_PREV_ID
};